import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: calc(100% - 40rem);
  @media (max-width: ${({ theme }) => theme.breakPoints.smallDesktop * theme.percentBaseResponsive}rem) {
    width: 100%;
  }
`;

export const ContainerButton = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 3.98rem;
  gap: 1.6rem;
  @media (max-width: ${({ theme }) => theme.breakPoints.landscapeTablet *
    theme.percentBaseResponsive}rem) {
    margin-top: ${({ theme }) => theme.spaces.s}rem;
  }
  @media (max-width: ${({ theme }) => theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    margin-top: ${({ theme }) => theme.spaces.l}rem;
    justify-content: center;
  }
`;

